import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from "react-helmet";
import { FiBookOpen, FiExternalLink, FiMail, FiLock, FiArrowLeft } from "react-icons/fi";
import "../../../assets/css/home.css";

function BusinessCommunication() {
  return (
    <>
      <Helmet>
        <title>Business Communication | eLuminous Technologies</title>
      </Helmet>

      {/* Hero */}
      <section className="training-hero">
        <div className="container">
          <Link to="/" className="training-back-link">
            <FiArrowLeft /> Back to Home
          </Link>
          <div className="training-hero-row">
            <div className="training-hero-icon">
              <FiBookOpen />
            </div>
            <div>
              <h1 className="training-hero-title">Business Communication</h1>
              <span className="training-hero-badge">Training Module</span>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="training-content">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="training-card">
                <div className="training-greeting">Dear Team,</div>
                <p>
                  In today's fast-paced and interconnected world, effective communication plays a pivotal role in driving success, both on an individual level and as a cohesive team.
                </p>
                <p>
                  We have launched Communication Module, designed to empower and enrich our employees' learning experience. This module has been carefully crafted to strengthen our communication skills, foster effective collaboration, and facilitate seamless information exchange throughout our organization.
                </p>
                <p>
                  Throughout this module, you will have access to a range of resources, including interactive videos, engaging quizzes, practical exercises, and supplementary materials to reinforce your learning.
                </p>
                <p>
                  We encourage you to take advantage of these resources to actively engage with the module content and apply the concepts to your daily work interactions.
                </p>

                <div className="training-divider"></div>

                <h5 className="training-section-title">Course Access</h5>
                <Link
                  to="https://www.udemy.com/course/professional-communication-and-business-writing/learn/lecture/25443052#overview"
                  target="_blank"
                  className="training-course-link"
                >
                  <div className="training-course-link-inner">
                    <div className="training-course-icon">
                      <FiExternalLink />
                    </div>
                    <div>
                      <span className="training-course-name">Business Communication Skills: Business Writing & Grammar</span>
                      <span className="training-course-platform">Udemy Course</span>
                    </div>
                  </div>
                </Link>

                <div className="training-credentials">
                  <h6 className="training-credentials-title">Login Credentials</h6>
                  <div className="training-credential-row">
                    <FiMail className="training-credential-icon" />
                    <div>
                      <span className="training-credential-label">Email</span>
                      <span className="training-credential-value">leena_k@eluminoustechnologies.com</span>
                    </div>
                  </div>
                  <div className="training-credential-row">
                    <FiLock className="training-credential-icon" />
                    <div>
                      <span className="training-credential-label">Password</span>
                      <span className="training-credential-value">Eluminous@123</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default BusinessCommunication
